import { COMPASS_URL } from 'src/constants';


export const REFRESH_WEBAPP_TOKEN_URL = '/auth/refresh_webapp_token';
export const LOGOUT_URL = '/auth/logout';

export const PARTY_MODAL_BASE_URL_OVERRIDE =
  process.env.NODE_ENV === 'development' ? window.location.origin : '';
